export const formatNumber = (value, decimals = 2) => {
	const num = parseFloat(value);

	if (isNaN(num)) {
		return "0";
	}

	const hasSignificantDecimals = num % 1 !== 0;

	return num.toLocaleString("es-CL", {
		minimumFractionDigits: 0,
		maximumFractionDigits: hasSignificantDecimals ? decimals : 0,
	});
};

export const truncateToDecimals = (value, decimals) => {
	const factor = Math.pow(10, decimals);
	return Math.trunc(value * factor) / factor;
};

export const formatNumberStrict = (value, decimals = 2) => {
	const num = Number(value);

	if (!Number.isFinite(num)) {
		throw new Error("El valor debe ser un número válido");
	}

	const hasSignificantDecimals = num % 1 !== 0;

	return num.toLocaleString("es-CL", {
		minimumFractionDigits: 0,
		maximumFractionDigits: hasSignificantDecimals ? decimals : 0,
	});
};
